export const getLadderProgress = (ladder, ladderProgress) => {
  return (
    (ladderProgress || []).find(
      (progress) => String(progress?.ladderId) === String(ladder?.id),
    ) || {
      overallStatus: "NOT_STARTED",
    }
  );
};

// Given a ladder from the CMS and a ladderProgress from the user's profile,
// return the status of the ladder
export const getLadderStatus = (ladder, ladderProgress) => {
  return (
    getLadderProgress(ladder, ladderProgress)?.overallStatus || "NOT_STARTED"
  );
};

// Given a ladder status, return a label for that status
export const getLadderStatusLabel = (status) => {
  switch (status) {
    case "COMPLETED":
      return "Completed";
    case "IN_PROGRESS":
      return "In Progress";
    default:
      return "Not Started";
  }
};
